import { Box } from '@mui/material';
import { PROJECT_MEMBERSHIP_ROLES } from '../../../core/constants';
import { EnumField, FieldProps } from 'framework/ui/field';
import { AppIconLabel } from 'framework/ui/mui-builder';

const ProjectTeamMemberRoleField = ({ ...props }: FieldProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        '& #app-icon-span-id': {
          mr: '5px !important',
        },
      }}
    >
      <AppIconLabel sxIcon={{ width: '14px' }} icon="rLetter" tooltipTitle="Project role" />
      <EnumField options={PROJECT_MEMBERSHIP_ROLES} {...props} />
    </Box>
  );
};

export default ProjectTeamMemberRoleField;
